import { userStatuses } from "../../../app/config/userStatuses";
import {format} from "../../../utils/timeZoneUtils";

export const infoFieldsArray = [
    {
        name: 'id',
    },
    {
        name: 'createdAt',
        convert: (value) => format(value)
    },
    {
        name: 'reportsAmount',
    },
    {
        name: 'isBlocked',
        modelName: 'isBlocked',
        items: userStatuses
    },
    {
        name: 'email',
        modelName: 'Email',
    },
    {
        name: 'firstname',
        modelName: 'Firstname',
    },
    {
        name: 'lastname',
        modelName: 'Lastname',
    }
];